module.exports = __webpack_public_path__ + "img/places.c0224ac6.svg";